class RestoreTemplateCtrl {
  constructor($scope, $window, $timeout, $uibModal, TemplateService, FlashService) {
    'ngInject';
    Object.assign(this, { $scope, $window, $timeout, $uibModal });
    this.ts = TemplateService;
    this.fs = FlashService;
    this.loading = false;
  }

  $onInit() { 
    this.createNewVersion = !this.template.restoredVersion;
  }

  async restoreVersion() {
    if (!this.versionRecord) {
      this.fs.error('No version record provided');
      return;
    }
    if (this.template.published && !confirm("WARNING: Restoring a published template may break existing links and event hooks (if target tables change). Do you want to continue?")) return;

    this.loading = true;
    
    try {
      await this.ts.restoreTemplateVersion(this.template, this.versionRecord.versionNumber, this.createNewVersion);
      this.onUpdate();
    } catch (error) {
      this.fs.error(error.message || 'Failed to restore template version');
      this.onUpdate();
    }
  }

  cancelModal() {
    this.onCancel();
  }

  closeModal() {
    this.onCancel();
  }
}

export default {
  bindings: {
    versionRecord: '<',
    template: '<',
    onUpdate: "&",
    onCancel: "&"
  },
  templateUrl: 'form-builder/restore-template/restore-template.component.html',
  controller: RestoreTemplateCtrl
};
